import {combine, merge, sample} from 'effector';

import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {isAdmin$} from 'models/auth';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    BillingInvoicesGate,
    billingList$,
    defaultFilters,
    defaultSortings,
    filters$,
    filtersChanged,
    filtersReset,
    loadBillingInvoicesDataFx,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
    changeInvoiceStatusFx,
    setInvoiceStatusChangeModalHandler,
    searchByIdChanged,
    searchByTinChanged,
    searchByIrnChanged,
    searchById$,
    searchByTin$,
    searchByIrn$,
    downloadInvoiceFx,
} from './index';

billingList$
    .on(loadBillingInvoicesDataFx.done, (_, {result}) => result)
    .reset(BillingInvoicesGate.close);

pageNumber$.reset(
    filtersChanged,
    sortingsChanged,
    stateReset,
    searchByIdChanged,
    searchByTinChanged,
    searchByIrnChanged,
);
pageSize$.reset(stateReset);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

sample({
    clock: merge([
        changeInvoiceStatusFx.done,
        BillingInvoicesGate.open,
        pageNumberChanged,
        pageSizeChanged,
        tableStateChanged,
        searchByIdChanged,
        searchByTinChanged,
        searchByIrnChanged,
    ]),
    source: combine({
        sortings: sortings$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        searchById: searchById$,
        searchByTin: searchByTin$,
        searchByIrn: searchByIrn$,
        isAdmin: isAdmin$,
    }),
    fn: ({
        pageNumber,
        pageSize,
        filters,
        sortings,
        searchById,
        searchByTin,
        searchByIrn,
        isAdmin,
    }) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        searchById,
        searchByTin,
        searchByIrn,
        isAdmin,
    }),
    target: loadBillingInvoicesDataFx,
});

loadBillingInvoicesDataFx.failData.watch((err) => showRestError(err as RestError));
changeInvoiceStatusFx.failData.watch((err) => showRestError(err as RestError));
changeInvoiceStatusFx.done.watch(() => {
    toast.success(i18next.t('pages.profile.billing.invoiceStatusChange.success'));
    setInvoiceStatusChangeModalHandler({
        show: false,
        data: null,
    });
});

downloadInvoiceFx.failData.watch((err) => showRestError(err as RestError));
